<template>
  <div landing>
    <p class="bg"></p>
    <div class="container">
      <p>표준.인증의 모든것</p>
      <ul>
        <li class="kcl">
          <a :href="`${base('kcl')}`">kcl</a>
          <div class="link">
            <a :href="`${base('kcl')}admin`">관리자 사이트</a>
            <a :href="`${base('kcl')}judge`">심사원 사이트</a>
            <a :href="`${base('kcl')}committee`">인증위원 사이트</a>
          </div>
        </li>
        <li class="ktc">
          <a :href="`${base('ktc')}`">ktc</a>
          <div class="link">
            <a :href="`${base('ktc')}admin`">관리자 사이트</a>
            <a :href="`${base('ktc')}judge`">심사원 사이트</a>
            <a :href="`${base('ktc')}committee`">인증위원 사이트</a>
          </div>
        </li>
        <li class="ktr">
          <a :href="`${base('ktr')}`">ktr</a>
          <div class="link">
            <a :href="`${base('ktr')}admin`">관리자 사이트</a>
            <a :href="`${base('ktr')}judge`">심사원 사이트</a>
            <a :href="`${base('ktr')}committee`">인증위원 사이트</a>
          </div>
        </li>
        <li class="kilt">
          <a :href="`${base('kilt')}`">kilt</a>
          <div class="link">
            <a :href="`${base('kilt')}admin`">관리자 사이트</a>
            <a :href="`${base('kilt')}judge`">심사원 사이트</a>
            <a :href="`${base('kilt')}committee`">인증위원 사이트</a>
          </div>
        </li>
        <li class="fiti">
          <a :href="`${base('fiti')}`">fiti</a>
          <div class="link">
            <a :href="`${base('fiti')}admin`">관리자 사이트</a>
            <a :href="`${base('fiti')}judge`">심사원 사이트</a>
            <a :href="`${base('fiti')}committee`">인증위원 사이트</a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="less">
  @import '../less/common';
  @import '../less/front';

  [landing] {
    .bg{.cover('@{common}/landing-bg.png');  .fix; .wh(100%); z-index: -1;}
    .container{ .p(200,0,50); .bg-xc; .tc; font-size:0; .-box;
      >p { .mb(20); .fs(60); color:#fff; }
      ul{
        li{.ib; .m(30,12,0);
          >a { .block; .wh(240,266); .bg-c }
          .link { .mt(16);
            >a{ .w(100%); color:#fff; .block; .m(6,0);.p(10,0);.fs(20); .bgc(#3d4452);}
          }
          &.ktc{
            >a{.bg('@{common}/landing-ktc.png'); &:hover { .bg('@{common}/landing-ktc-on.png');}}
            .link a{&:hover{.bgc(#2d38b6);}}
          }
          &.kcl {
            >a{.bg('@{common}/landing-kcl.png'); &:hover { .bg('@{common}/landing-kcl-on.png');}}
            .link a{&:hover{.bgc(#64b83c);}}
          }
          &.ktr {
            >a{.bg('@{common}/landing-ktr.png'); &:hover { .bg('@{common}/landing-ktr-on.png');}}
            .link a{&:hover{.bgc(#27c1b1);}}
          }
          &.kilt {
            >a{.bg('@{common}/landing-kilt.png'); &:hover { .bg('@{common}/landing-kilt-on.png');}}
            .link a{&:hover{.bgc(#dca158);}}
          }
          &.fiti {
            >a{.bg('@{common}/landing-fiti.png'); &:hover { .bg('@{common}/landing-fiti-on.png');}}
            .link a{&:hover{.bgc(#015daa);}}
          }
        }
      }
    }
  }

</style>

<script>
export default {
  created() {
    const { path } = this.$route;
    switch (window.location.host.split('.')[0]) {
      case 'kcl': location.href = `/kcl${path}`; break;
      case 'ktc': location.href = `/ktc${path}`; break;
      case 'ktr': location.href = `/ktr${path}`; break;
      case 'kilt': location.href = `/kilt${path}`; break;
      case 'fiti': location.href = `/fiti${path}`; break;
      default:
    }
  },
  methods: {
    base(type) {
      return location.host.indexOf('ksnara.net') !== -1 ? `https://${type}.ksnara.net/${type}/` : `${location.protocol}//${location.host}/${type}/`;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/route.vue